import { Assets } from '../../assets';
import { Colors, ResponsiveSpacing } from '../../utils';
import { Button } from '../Button';
import { Box, Flex } from '../Layout';
import { Text } from '../Text';

type DataLoaderWithRetryProps = {
  onClick: () => void;
  paddingBottom?: ResponsiveSpacing;
  paddingTop?: ResponsiveSpacing;
  paddingLeft?: ResponsiveSpacing;
  paddingRight?: ResponsiveSpacing;
  backgroundColor?: Colors;
  isLoading?: boolean;
  type?: 'inline' | 'input' | 'small' | 'large';
};

const paddings = {
  inline: { vertical: 0, horizontal: 0 },
  input: { vertical: 15, horizontal: 20 },
  small: { vertical: 20, horizontal: 30 },
  large: { vertical: 40, horizontal: 30 },
};

export const DataLoaderWithRetry = ({
  onClick,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  backgroundColor,
  isLoading,
  type,
}: DataLoaderWithRetryProps) => {
  paddingTop = paddingTop ?? (type ? paddings[type].vertical : undefined);
  paddingBottom = paddingBottom ?? (type ? paddings[type].vertical : undefined);
  paddingRight = paddingRight ?? (type ? paddings[type].horizontal : undefined);
  paddingLeft = paddingLeft ?? (type ? paddings[type].horizontal : undefined);
  return (
    <Flex
      flexDirection={['row']}
      backgroundColor={backgroundColor}
      columnGap={10}
      paddingBottom={paddingBottom}
      paddingLeft={paddingLeft}
      paddingRight={paddingRight}
      paddingTop={paddingTop}
    >
      {isLoading ? (
        <Assets.Loading
          width={40}
          marginLeft={type === 'inline' ? 0 : 'auto'}
          marginRight="auto"
          marginTop={-9}
          marginBottom={-9}
        />
      ) : (
        <>
          <Assets.TriangleCross color="black80" width={22} />
          <Flex flexDirection={['row', 'column', 'row']} alignItems={'baseline'} flexWrap="wrap">
            <Text color="black70">Data kunde inte laddas</Text>
            <Box marginLeft={[10, 10, 10]}>
              <Button onClick={onClick} styleAs="link">
                Försök igen
              </Button>
            </Box>
          </Flex>
        </>
      )}
    </Flex>
  );
};
